import { useStore as getStore } from "../../utils/useStore.js";
import sideBarFactory from "./sideBarFactory.js";

const initialState = () => ({
  content: null,
  lightBoxView: false,
  gridView: false,
  itemId: null,
  props: {},
});

const [SideBarProvider, useSideBar, withSideBar] = getStore(
  sideBarFactory,
  initialState,
  "Sidebar"
);

export const sideBarInitState = initialState();

export { useSideBar, SideBarProvider, withSideBar };

export default SideBarProvider;
